import { Component, NgZone } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';

import { State } from './../../providers/state';
import { LocationProvider } from './../../providers/locationProvider';

declare var google:any;
declare var gmaps: any;

@Component({
  selector: 'page-favorits',
  templateUrl: 'favorits.html'
})

export class Favorits {

  public locations: any = [];
  public locationsFiltered: any = [];
  public preFiximgurl: string = "https://res.cloudinary.com/mei/image/fetch/w_300,h_300,c_thumb/";

  constructor(public navCtrl: NavController, public navParams: NavParams, public locationProvider: LocationProvider, public state: State, private zone:NgZone) {}

  ionViewWillEnter() {
    this.locations = [];
    this.loadArray();
  }

  filtre (locations) {
    let favorits = this.state.returnImmbobles();
    return locations.filter((location) => {
      return favorits.some((id) => id===location['OBJECTID'])
    })
  }

  filterLocations () {
    this.locationsFiltered = this.filtre(this.locations);

    this.zone.run(() => {
      console.log('enabled time travel');
    });
  }

 loadArray() {
    let style = {
      fillColor: '#333388',
      fillOpacity: 0.35,
      strokeColor: '#FFFFFF',
      strokeWeight: 1,
      strokeOpacity: 1,
      zIndex: 0
    };

    let url = 'https://services.arcgis.com/WNsrZDHEJ88NE4N8/ArcGIS/rest/services/Espais_lliures_polígons/FeatureServer/0';
    let layer = new gmaps.ags.Layer(url);
    let params = {
      returnGeometry: true,
      where: "1 = 1",
      outFields: ["OBJECTID", "Poligon","Adreça_ubi","Tipologia","Sup_interv","Superf_m2","Règim_prop","Disponibil","Empresa_Im","Tl_1contac","Tl_2contac","E_mail","Contacte","Descripció","foto","web_immob"],
      overlayOptions: style
    };
    layer.query(params, (rs) => {
      rs.features.forEach(element => this.setupFeature(element));
      this.filterLocations();
    });

  }

  setupFeature (feat) {
    if(feat.geometry!=undefined){
      let g = feat.geometry[0];//V3 supports multiple rings, so should have only 1 element

      feat.attributes["geo"] = this.getPolyCenter(g);
      this.locations.push(feat.attributes);
    }
  }

  getPolyCenter(poly) {
    let lat = 0;
    let lng = 0;
    let c = 0;
    let paths = poly.getPaths();
    for (var j = 0, jc = paths.getLength(); j < jc; j++) {
      let path = paths.getAt(j);
      for (var k = 0, kc = path.getLength(); k < kc; k++) {
        let latlng = path.getAt(k);
        lat += latlng.lat();
        lng += latlng.lng();
        c++;
      }
    }
    return c > 0 ? { "lat" : lat / c, "lng" : lng / c } : null;
  }

  empty_locations(){
    return (this.locationsFiltered.length == 0)?true:false;
  }

  setImg(urlFoto){
    if(urlFoto == " "){
      return "assets/img/gris.jpg";
    }else{
      return this.preFiximgurl + urlFoto;
    }
  }

}



// WEBPACK FOOTER //
// ./src/pages/favorits/favorits.ts